import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");

if (container.hasChildNodes()) {
    // Page was prerendered — hydrate in place.
    ReactDOM.hydrateRoot(
        container,
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
} else {
    ReactDOM.createRoot(container).render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
}
